// SPDX-FileCopyrightText: 2026 Stadtplatz.de
//
// SPDX-License-Identifier: EUPL-1.2

import React from "react";
import { Link } from "react-router-dom";
import { UserPlus } from "lucide-react";
import Layout from "../../components/layout/Layout";
import { useKeycloak } from "../../context/KeycloakProvider";

const RegisterPage = () => {
  const { register } = useKeycloak();

  const handleRegister = () => {
    register();
  };

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div>
            <div className="mx-auto h-12 w-12 flex items-center justify-center rounded-full bg-green-100">
              <UserPlus className="h-6 w-6 text-green-600" />
            </div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Create your account
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Join Fair Urban Space
            </p>
          </div>

          <div className="mt-8 space-y-6">
            <div className="text-center">
              <button
                onClick={handleRegister}
                className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
              >
                <UserPlus className="h-5 w-5 mr-2" />
                Create account with Keycloak
              </button>
            </div>

            <div className="text-center">
              <Link to="/login" className="text-blue-600 hover:text-blue-500">
                Already have an account? Sign in
              </Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RegisterPage;
